import React from "react";
import { Inbox } from "lucide-react";

/* ---------------- shared building blocks for AP-021 dashboards -------------- */

export function StatCard({ label, value, icon: Icon, testid, accent }) {
  return (
    <div data-testid={testid}
         className="rounded-2xl border border-border bg-white p-5 md:p-6 relative overflow-hidden group">
      <div className="flex items-start justify-between gap-3">
        <div className="min-w-0">
          <p className="text-[11px] uppercase tracking-[0.14em] text-muted-foreground font-medium">{label}</p>
          <p className="mt-3 font-display text-2xl md:text-3xl font-bold tracking-tight text-foreground truncate">
            {value}
          </p>
        </div>
        <div className={`h-10 w-10 shrink-0 rounded-xl grid place-items-center ${accent ? "bg-primary/10 text-primary" : "bg-muted text-muted-foreground"}`}>
          <Icon className="h-5 w-5" strokeWidth={2} />
        </div>
      </div>
    </div>
  );
}

export function StatSkeleton() {
  return (
    <div className="rounded-2xl border border-border bg-white p-5 md:p-6 animate-pulse">
      <div className="h-3 w-24 bg-muted rounded" />
      <div className="mt-4 h-8 w-16 bg-muted rounded" />
    </div>
  );
}

export function PanelCard({ title, testid, icon: Icon, children }) {
  return (
    <div data-testid={testid} className="rounded-2xl border border-border bg-white">
      <div className="px-5 py-3 border-b border-border flex items-center gap-2">
        {Icon && <Icon className="h-4 w-4 text-muted-foreground" />}
        <h3 className="text-sm font-semibold">{title}</h3>
      </div>
      <div className="px-5 py-3">{children}</div>
    </div>
  );
}

export function PanelSkeleton() {
  return (
    <div className="space-y-2 animate-pulse py-2">
      {[...Array(4)].map((_, i) => (
        <div key={i} className="h-6 rounded bg-muted/70" />
      ))}
    </div>
  );
}

export function EmptyState({ label, icon: Icon = Inbox }) {
  return (
    <div className="py-8 flex flex-col items-center justify-center text-center gap-2 text-muted-foreground">
      <Icon className="h-8 w-8 opacity-40" />
      <p className="text-sm">{label}</p>
    </div>
  );
}
